export const formatCompactNumber = (value: number | string): string => {
	const num = typeof value === 'string' ? parseFloat(value) : value;

	if (num >= 1_000_000_000) {
		return `${(num / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`;
	}
	if (num >= 1_000_000) {
		return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
	}
	if (num >= 1_000) {
		return `${(num / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
	}
	return num.toLocaleString();
};

export const formatWithCommas = (value: number | string): string => {
	const num = typeof value === 'string' ? parseFloat(value) : value;
	return num.toLocaleString();
};
